import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import * as yup from 'yup';
import Form from 'react-bootstrap/Form';
import { useToasts } from 'react-toast-notifications';
import CustomInput from '../../views/ui-elements/input/CustomInput';
import CustomSelect from '../../views/ui-elements/input/CustomSelect';
import CustomButtons from '../../views/ui-elements/Buttons/CustomButtons';
import CustomDangerButton from '../../views/ui-elements/Buttons/CustomDangerButton';
import { reset } from 'redux-form';
import Patients from '../../modules/Patients';
import { ImCross } from 'react-icons/im';
import { DatePicker } from 'antd';
import moment from 'moment';
import LdcApi from '../../LdcApis';
import Autocomplete from '../../components/Apt/Autocomplete/Autocomplete';
import { Spin } from 'antd';
import { BsFillCloudUploadFill } from 'react-icons/bs';
import AutoAppointmentComplete from '../../components/Apt/AutoAppointmentComplete/AutoAppointmentComplete';
import { useFormikContext } from 'formik';

import dayjs from 'dayjs';
import { FaCaretDown } from 'react-icons/fa';

const validationSchema = yup.object().shape({
  patientName: yup.string().required('Patient Name is required'),
  // notes: yup.string().required('Notes are required'),
});
// const validationSchema = yup.object().shape({
//   ID: yup.number().nullable().required("ID is required"),
//   patientId: yup.number().nullable().required("Patient ID is required"),
//   dateOfComplaint: yup
//     .string()
//     .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format")
//     .required("Date of Complaint is required"),
//   appointmentId: yup.number().nullable().required("Appointment ID is required"),
//   complaintToId: yup
//     .number()
//     .nullable()
//     .required("Complaint To ID is required"),
//   dateOfAcknowledged: yup
//     .string()
//     .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format")
//     .required("Date of Acknowledgement is required"),
//   deadLineToReply: yup
//     .string()
//     .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format")
//     .required("Deadline to Reply is required"),
//   finalReplyDate: yup
//     .string()
//     .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format")
//     .required("Final Reply Date is required"),
//   outCome: yup.string().nullable().required("Outcome is required"),
//   notes: yup.string().nullable().required("Notes are required"),
//   complaintToType: yup
//     .string()
//     .oneOf(["D", "OtherType"], "Invalid Complaint Type")
//     .required("Complaint Type is required"),
// });

const outcome = [
  { id: 'Upheld', name: 'Upheld' },
  { id: 'NotUpheld', name: 'Not Upheld' },
  { id: 'Pending', name: 'Pending' },

];

function EditPatientComplaintsDialog({
  assignedData,
  editJobData,
  showEditJobPatient,
  setShowEditJobPatient,
  handleClose,
  getJobDetailsPatient,
  getCaegoryListStatus,
  getRoleListStatus,
  loadingForDelete,
  setLoadingForDelete,
  roleListStatus,
  patientJobDetails,
  getComplaintsDetailsPatient,
  patientLoader,
  selectedRange,
  patientId,
  resetAllStates
}) {
  console.log('showEditJobPatient', showEditJobPatient);
  console.log('editJobData sdfs', editJobData);
  // Update formValues when editJobData changes
  const photoUploadRef = useRef(null);
  const [previousPhoto, setPreviousPhoto] = useState(null);
  const [selectedPhotoFile, setSelectedPhotoFile] = useState([]);
  const [uploadPhotoError, setUploadPhotoError] = useState(false);
  const { addToast } = useToasts();
  const [dueDate, setDueDate] = useState(null);
  const [deuDateError, setDueDateError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteTaskModal, setDeleteTaskModal] = useState(false);
  const [selectDocument, setSelectDocument] = useState('');
  // const [selectDocumentError, setSelectDocumentError] = useState(false);
  const [documentTabData, setDocumentTabData] = useState([]);
  const [alreadySelectedFile, setAlreadySelectedFile] = useState([]);
  const [showOtherField, setShowOtherField] = useState(false);
  const [jobData, setjobData] = useState('');
  const [formValues, setFormValues] = useState({
    patientName: '',
    notes: '',
    dateOfComplaint: '',
    patientId: '',
    appointmentId: '',
    mobile: '',
    email: '',
    appointmentDate: '',
    complaintTo: '',
    complaintToId: '',
    complaintToType: '',
    dateOfAcknowledged: '',
    deadLineToReply: '',
    finalReplyDate: '',
    outCome: '',
    note: '',
    ID: '',
    userName: '',
  });
  console.log('formValues', formValues);
  const [modelData, setmodelData] = useState(false);

  // console.log('editJobData', editJobData);

  useEffect(() => {
    console.log('editJobData', editJobData);
    if (editJobData) {
      setFormValues({
        patientName: editJobData.patientName || '',
        notes: editJobData.notes || '',
        dateOfComplaint: editJobData.dateOfComplaint
          ? dayjs(editJobData.dateOfComplaint).format('DD/MM/YYYY')
          : '',
        mobile: editJobData.mobile || '',
        email: editJobData.email || '',
        ID: editJobData.ID || 0,
        complaintTo: editJobData.complaintTo || '',

        appointmentDate: editJobData.appointmentDate
          ? dayjs(editJobData.appointmentDate).format('DD/MM/YYYY')
          : '',
        patientId: editJobData.patientId || '',
        appointmentId: editJobData.appointmentId || '',
        complaintToId: editJobData.complaintToId || '',
        complaintToType: editJobData.complaintToType || '',

        dateOfAcknowledged: editJobData.dateOfAcknowledged
          ? dayjs(editJobData.dateOfAcknowledged).format('DD/MM/YYYY')
          : '',
        deadLineToReply: editJobData.deadLineToReply
          ? dayjs(editJobData.deadLineToReply).format('DD/MM/YYYY')
          : '',
        finalReplyDate: editJobData.finalReplyDate
          ? dayjs(editJobData.finalReplyDate).format('DD/MM/YYYY')
          : '',

        outCome: editJobData.outCome || '',
        note: editJobData.note || '',
        userName: editJobData.userName || '',
      });
    }
  }, [editJobData]);

  useEffect(() => {
    console.log('formValues?.patientName', formValues?.patientName);
    if (formValues?.patientName !== '') {
      setShowEditJobPatient(true);
    }
  }, [formValues, editJobData]);

  // Populate form when editJobData is available
  useEffect(() => {
    if (selectedRange && selectedRange.length === 2) {
      const startDate = dayjs(selectedRange[0]).format('YYYY-MM-DD');
      const endDate = dayjs(selectedRange[1]).format('YYYY-MM-DD');
      console.log('startDate  dfasf', startDate);
   //   fetchDocumentsTabData(editJobData?.patientId, startDate, endDate);
    }
  }, [selectedRange, editJobData]);

  console.log('selectedRange', selectedRange);

  // useEffect(() => {
  //   if (editJobData.getAllFile?.length > 0) {
  //     setAlreadySelectedFile([...editJobData.getAllFile]);
  //   } else {
  //     setAlreadySelectedFile([]);
  //   }
  // }, [editJobData, showEditJobPatient]);

  useEffect(() => {
    const fetchDocumentsTabData = (patientId) => {
      console.log('patientId', patientId);
      const startDate = dayjs(selectedRange[0]).format('YYYY-MM-DD');
      const endDate = dayjs(selectedRange[1]).format('YYYY-MM-DD');
      LdcApi({
        method: 'GET',
        url: `PatientsComplaintTracker/GetPatientsComplaintTrackerList?id=${patientId}&startDate=${startDate}&endDate=${endDate}&status=`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          if (response?.status === 200) {
            setDocumentTabData(response?.data);
            setSelectDocument(editJobData.pAttachmentId);
          }
        })
        .catch((error) => {});
    };
    if (showEditJobPatient) {
      fetchDocumentsTabData(patientId);
    } else {
      setDocumentTabData([]);
      // setSelectDocumentError(false);
      setSelectDocument('');
    }
  }, [showEditJobPatient]);

  const updateTable = (id) => {
    console.log('updatetable',  )
    setAttachmentLoader(true);
    const startDate = dayjs(selectedRange[0]).format('YYYY-MM-DD');
    const endDate = dayjs(selectedRange[1]).format('YYYY-MM-DD');

    LdcApi({
      method: 'GET',
      url: `PatientsComplaintTracker/GetPatientsComplaintTrackerList?startDate=${startDate}&endDate=${endDate}&status=`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response?.status === 200) {
          setDocumentTabData(response?.data);
        }
      })
      .catch((error) => {});
  };
  // const [patients, setPatients] = useState([]);
  const [isPatientList, setIsPatientList] = useState(false);
  const [patientList, setPatientList] = useState([]);

  const patientFullName = `${editJobData?.patientName} ${editJobData?.patientId}`;
  const [searchDoctor, setSearchDoctor] = useState('');
  const [patientName, setPatientName] = useState('');
  const [doctorName, setDoctorName] = useState('');
  const [doctorList, setDoctorList] = useState([]);
  const [isDoctorList, setIsDoctorList] = useState(false);
  const [doctorLoader, setDoctorLoader] = useState(false);

  const [attachmentLoader, setAttachmentLoader] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [replyDate, setReplyDate] = useState(dayjs());
  const [incidentClass, setIncidentClass] = useState(false);

  const [acknowledgementDate, setAcknowledgementDate] = useState(dayjs());

  const [incidentDate, setIncidentDate] = useState('');
  const [appointmentDates, setAppointmentDates] = useState([]);
  const [showAutocomplete, setShowAutocomplete] = useState(false);
  const complaintDate = dayjs().startOf('day'); // Set today
  const deadlineDate = calculateDeadlineDate(complaintDate); // Set deadline date
  // useEffect(() => {
  //   setSmsTemplate({
  //     patientName: '',
  //     fullName: patientFullName,
  //     mobile: '',
  //     email: '',
  //     doctorInvolved: '',
  //     dateOfComplaint: complaintDate
  //       ? dayjs(complaintDate).format('YYYY-MM-DD')
  //       : '',
  //     // acknowledgementDate: acknowledgementDate
  //     //   ? dayjs(acknowledgementDate).format('YYYY-MM-DD')
  //     //   : '',
  //     deadlineDate: deadlineDate
  //       ? dayjs(deadlineDate).format('YYYY-MM-DD')
  //       : '',
  //     acknowledgementDate: today,
  //     replyDate: today,
  //   });
  // }, [patientJobDetails]);

  useEffect(() => {
    if (documentTabData.length > 0) {
    }
  }, [documentTabData]);

  function calculateDeadlineDate(startDate, workingDays = 28) {
    let currentDate = dayjs(startDate);
    let addedDays = 0;

    while (addedDays < workingDays) {
      if (currentDate.day() !== 0) {
        // Count only Monday-Saturday (skip Sundays)
        addedDays++;
      }
      currentDate = currentDate.add(1, 'day'); // Move to the next day **after** counting
    }

    return currentDate.subtract(1, 'day'); // Adjust for the last extra increment
  }

  // Example Usage:
  console.log(calculateDeadlineDate('2024-03-22', 28)); // Should return 23rd April 2024

  const today = dayjs().format('YYYY-MM-DD');
  // const [smsTemplate, setSmsTemplate] = useState({
  //   patientId: "",
  //   // dateOfComplaint: complaintDate
  //   //   ? dayjs(complaintDate).format('YYYY-MM-DD')
  //   //   : '',
  //   dateOfComplaint: complaintDate.format("YYYY-MM-DD"),
  //   // deadlineDate: deadlineDate.format('YYYY-MM-DD'),
  //   appointmentId: "",
  //   complaintToId: "",
  //   acknowledgementDate: today,
  //   deadlineDate: deadlineDate.format("YYYY-MM-DD"),
  //   complaintToType: "D",
  //   replyDate: today,
  //   outCome: "",
  //   notes: "",
  //   patientName: "",
  //   mobile: "",
  //   email: "",
  //   appointmentDate: "",
  //   complaintTo: "",
  //   dateOfAcknowledged: "",
  // });
  // console.log("smsTemplate--->", smsTemplate);
  console.log('deadlineDate', deadlineDate.format('YYYY-MM-DD'));

  console.log('patientJobDetails', patientJobDetails);

  const onSearchPatient = (e) => {
    let val = e.target.value;
    val = val.replace(/^\s/, '');
    // setSmsTemplate((smsTemplate) => ({
    //   ...smsTemplate,
    //   fullName: val,
    // }));
    setDocumentTabData([]);
    setSelectDocument('');
    let tempSuggestion = [];
    if (val.length >= 3) {
      Patients.getExistPatients(val, (response) => {
        console.log('responsesfdas', response);
        if (response?.status === 'success') {
          if (response?.data.length > 0) {
            setIsPatientList(true);
            setPatientList(response.data);
          } else {
            setIsPatientList(false);
            setPatientList([]);
          }
        }
      });
    } else {
      setIsPatientList(false);
      setPatientList([]);
    }
  };
  function calculateDeadlineDate(startDate, workingDays = 28) {
    let currentDate = dayjs(startDate);
    let addedDays = 0;

    while (addedDays < workingDays) {
      if (currentDate.day() !== 0) {
        // Count only Monday-Saturday (skip Sundays)
        addedDays++;
      }
      currentDate = currentDate.add(1, 'day'); // Move to the next day **after** counting
    }

    return currentDate.subtract(1, 'day'); // Adjust for the last extra increment
  }

  const onPatientItem = (item, setFieldValue) => {
    console.log('item gsdgsdfhgshrbhhytyh', item);
    // setSmsTemplate({
    //   ...smsTemplate,
    //   patientId: item.id,
    //   patientName: item.fullName,
    //   fullName: item.fullName,
    //   // fullName: item.fullName,
    //   mobile: item.mobile,
    //   email: item.email,
    // });
    // Update Formik fields
    if (item) {
      setFieldValue('patientName', item.fullName);
      setFieldValue('patientId', item.id);

      setFormValues({ ...formValues, patientId: item.id });
    } else {
      // Reset if no patient is selected
      setFieldValue('patientName', '');
      setFieldValue('patientId', '');
    }
    // const formattedPatientName = `${item.fullName} :: ${item.id}`;
    // setFieldValue("patientName", formattedPatientName);
    setFieldValue('mobile', item.mobile);
    setFieldValue('email', item.email);
    setFieldValue('patientId', item.id);
   //fetchDocumentsTabData(item.id);
    setPatientName(item.fullName + ` :: ${item.id}`);
    setIsPatientList(false);
    setPatientList([]);
  };
  const onDoctorItem = (item, setFieldValue) => {
    console.log('Selected Doctor--->', item);

    // Update Formik form values
    setFieldValue('complaintTo', item.name); // Update complaintTo field
    setFieldValue('complaintToId', item.id); // Update complaintToId
    setFieldValue('complaintToType', item.type); // Update complaintToType

    // Hide doctor list after selection
    setIsDoctorList(false);
  };

  const onSearchDoctor = (e) => {
    let val = e.target.value.trim(); // Remove leading spaces
    // setSmsTemplate({
    //   ...smsTemplate,
    //   doctorInvolved: val, // Update field
    // });

    let tempSuggestion = [];

    if (val.length >= 3) {
      Patients.getStaffAndUser(val, (response) => {
        console.log('responseStaff', response);
        if (response?.status === 'success') {
          if (response?.data?.data?.length > 0) {
            console.log('hit');
            setIsDoctorList(true);
            setDoctorList(response.data?.data); // Store doctors in state
          } else {
            setIsDoctorList(false);
            setDoctorList([]); // No results found
          }
        }
      });
    } else {
      setIsDoctorList(false);
      setDoctorList([]); // Reset list if less than 3 chars
    }
  };

  const fetchDocumentsTabData = (id) => {
    setAttachmentLoader(true);
    LdcApi({
      method: 'GET',
      url: `Patients/GetPatientAttachmentsBypatientID?patientId=${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response?.status === 200) {
          setAttachmentLoader(false);
          setDocumentTabData(response?.data);
        }
      })
      .catch((error) => {});
  };
  const fetchAppointmentDates = (patientId) => {
    LdcApi({
      method: 'GET',
      url: `Appointment/GetAppointmentDateByPatient?patientId=${patientId}`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        console.log('response', response);
        if (
          response?.data?.status?.isSuccess &&
          response?.data?.data?.length > 0
        ) {
          setAppointmentDates(response.data.data);
          setShowAutocomplete(true);
        } else {
          setShowAutocomplete(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching appointment dates:', error);
        setAppointmentDates([]);
        setShowAutocomplete(false);
      });
  };

  // const submitComplaint = async (values) => {
  //   setBtnDisable(true);

  //   if (!smsTemplate.appointmentId) {
  //     setIncidentClass(true);
  //     addToast(" Please select incident date", {
  //       appearance: "warning",
  //     });
  //     setBtnDisable(false);
  //     return; // Stop function execution
  //   }

  //   const complaintData = {
  //     ID: 0,
  //     patientId: smsTemplate.patientId,
  //     dateOfComplaint: smsTemplate.dateOfComplaint,
  //     appointmentId: smsTemplate.appointmentId,
  //     complaintToId: smsTemplate.complaintToId,
  //     complaintToType: smsTemplate.complaintToType || "D",
  //     dateOfAcknowledged: smsTemplate.acknowledgementDate,
  //     deadLineToReply: smsTemplate.deadlineDate,
  //     finalReplyDate: smsTemplate.replyDate,
  //     outCome: smsTemplate.outcome,
  //     note: smsTemplate.notes,
  //   };

  //   console.log("complaintData", complaintData);

  //   const hasValidationError = Object.values(validationError).some(
  //     (err) => err === true
  //   );

  //   if (hasValidationError) {
  //     setBtnDisable(false);
  //     addToast("All Fields are mandatory to fill.", { appearance: "warning" });
  //   } else {
  //     try {
  //       const res = await LdcApi({
  //         method: "POST",
  //         url: "PatientsComplaintTracker/UpsertPatientsComplaintTracker",
  //         data: complaintData,
  //       });

  //       if (res.data.status.isSuccess === true) {
  //         addToast("Complaint saved successfully.", { appearance: "success" });

  //         setPatientName("");
  //         getComplaintsDetailsPatient();
  //         // **Clear Local State**
  //         setSmsTemplate({
  //           patientId: "",
  //           dateOfComplaint: "",
  //           appointmentId: "",
  //           complaintToId: "",
  //           acknowledgementDate: "",
  //           deadlineDate: "",
  //           replyDate: "",
  //           outcome: "",
  //           notes: "",
  //         });
  //         window.location.reload();
  //         setPatientName("");
  //         setIncidentDate("");
  //         setSelectDocument("");
  //         setDocumentTabData([]);
  //         setIsPatientList(false);
  //         setPatientList([]);
  //       } else {
  //         addToast("Failed to save complaint.", { appearance: "error" });
  //       }
  //     } catch (err) {
  //       console.log("err", err);
  //       addToast("Something went wrong. Please try again.", {
  //         appearance: "error",
  //       });
  //     } finally {
  //       setBtnDisable(false);
  //     }
  //   }
  // };

  const [validationError, setValidationError] = useState({
    patientName: false,
    notes: false,
    department: false,
    priority: false,
    outcome: false,
    assignedTo: false,
    doctorInvolved: false,

    // selectDocument:false,
  });
  console.log('validationError', validationError);
  const savePatient = () => {
    console.log('save');
  };

  const saveEditPatient = (values) => {
    console.log('Editing Complaint with Values:', values);

    let updatedData = {
      ID: values.ID || 0,
      patientId: values.patientId || '',
      dateOfComplaint: formValues.dateOfComplaint
        ? dayjs(formValues.dateOfComplaint, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : null,
      appointmentId: values.appointmentId || '',
      complaintToId: values.complaintToId || '',
      dateOfAcknowledged: formValues.dateOfAcknowledged
        ? dayjs(formValues.dateOfAcknowledged, 'DD/MM/YYYY').format(
            'YYYY-MM-DD'
          )
        : null,
      deadLineToReply: formValues.deadLineToReply
        ? dayjs(formValues.deadLineToReply, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : null,
      finalReplyDate: formValues.finalReplyDate
        ? dayjs(formValues.finalReplyDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : null,
      outCome: values.outCome || '',
      note: values.notes || '',
      complaintToType: values.complaintToType || 'D',
    };

    console.log('updatedData', updatedData);
    try {
      setLoading(true);

      Patients.addComplaints(updatedData, (response) => {
        console.log('response__-->', response);
        if (response?.data?.status?.isSuccess) {
          addToast('Complaint updated successfully.', {
            appearance: 'success',
          });
          // handleClose(); // Close the modal or form
          // getJobDetailsPatient();
          // getRoleListStatus(); // Refresh role list
          setLoading(false);
          setShowEditJobPatient(false);
          // ✅ Fetch updated document data after saving
          updateTable();
          resetAllStates();

      //       setTimeout(() => {
      //   window.location.reload();
      // }, 700);
        } else {
          addToast('Error updating complaint.', { appearance: 'error' });
          setLoading(false);
        }
      });
    } catch (error) {
      console.error('Edit Complaint Error:', error);
      addToast('Something went wrong. Try again later.', {
        appearance: 'error',
      });
      setLoading(false);
    }
  };

  // const saveEditPatient = (values) => {
  //   console.log("values ->", values);
  //   let editData = {
  //     ID: values.ID || "", //hgj
  //     patientId: values.patientId || "",
  //     dateOfComplaint: values.dateOfComplaint || "",
  //     appointmentId: values.appointmentId || "", //gtfg
  //     complaintToId: values.complaintToId || "", //hgfhgf
  //     dateOfAcknowledged: values.dateOfAcknowledged || "",
  //     deadLineToReply: values.deadLineToReply || "",
  //     finalReplyDate: values.finalReplyDate || "",
  //     outCome: values.outCome || "",
  //     notes: values.notes || "",
  //     complaintToType: values.complaintToType || "D",
  //   };

  //   console.log("hit", values);
  //   console.log("formData", editData);
  //   try {
  //     setLoading(true);
  //     Patients.addComplaints(editData, (response) => {
  //       if (response?.status === "success") {
  //         addToast("Task updated successfully.", { appearance: "success" });
  //         handleClose();
  //         getJobDetailsPatient();
  //         getCaegoryListStatus();
  //         getRoleListStatus();
  //         setDueDate(null);
  //         setDueDateError(false);
  //         photoUploadRef.current.value = null;
  //         setSelectedPhotoFile([]);
  //         setLoading(false);
  //         setSelectDocument("");
  //         setDocumentTabData([]);
  //         setAlreadySelectedFile([]);
  //         // setSelectDocumentError(false);
  //       } else {
  //         // addToast('Error Occured while Editing Task', { appearance: 'error' });
  //         setLoading(false);
  //       }
  //     });
  //   } catch (err) {
  //     console.log("err", err);
  //   }
  // };
  let formattedDate, formattedTime;
  if (editJobData.createdOn) {
    const [date, time] = editJobData.createdOn?.split('T');
    const [year, month, day] = date?.split('-');
    formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
    formattedTime = time?.slice(0, 5);
  }

  const fetchImageAsBlob = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return blob;
  };
  useEffect(() => {
    const handlePhotoForFile = async () => {
      const blob = await fetchImageAsBlob(editJobData.filePath);
      const file = new File([blob], 'image.png', { type: blob.type });
      setPreviousPhoto(file);
    };
    const handleDate = () => {
      if (editJobData.duedate) {
        const dateObject = new Date(editJobData.duedate);
        const momentDate = dayjs(dateObject);
        setDueDate(momentDate);
      } else {
        setDueDate(null);
      }
    };
    if (showEditJobPatient) {
      handlePhotoForFile();
      handleDate();
    }
  }, [editJobData, showEditJobPatient]);
  // useEffect(()=>{
  // },[selectedPhotoFile])
  const handlePhoto = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles) {
      setUploadPhotoError(false);
      setSelectedPhotoFile([...selectedPhotoFile, ...newFiles]);
    }
  };
  const handleDateChange = (date) => {
    if (date !== null) setDueDateError(false);
    if (date) {
      setDueDate(date);
    } else {
      setDueDate(null);
    }
  };
  const handleDeleteTask = () => {
     setDeleteTaskModal(true);
  };
const completelyDeletedTask = (compId) => {
  console.log('compId', compId);
  setLoadingForDelete(true);

  Patients.deleteComplaint(compId, (response) => {
    console.log('response', response)
    

    if (response?.data?.status?.isSuccess ) {
      // closeDeleteTaskPopup();
      setDeleteTaskModal(false);
       closeEditPopUp();
      addToast('Complaint deleted successfully', { appearance: 'success' });
      //  getCaegoryListStatus();
      //  getRoleListStatus();
        resetAllStates();
    } else {
      addToast('Complaint could not be deleted', {
        appearance: 'error',
      });
    }

    setLoadingForDelete(false);
  });
};

  const handleReplyDate = (date) => {
    if (date) {
      setReplyDate(date);

      // setSmsTemplate((prev) => ({
      //   ...prev,
      //   replyDate: dayjs(date).format("YYYY-MM-DD"), // Convert to YYYY-MM-DD
      // }));
    }
  };

  // const handleDeadlineDateChange = (date) => {
  //   if (date) {
  //     setDeadlineDate(date);
  //   }
  // };
  // const handleDateAcknowledgementChange = (date, dateString) => {
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     dateOfAcknowledged: date ? dateString : '', // Ensure empty values are properly handled
  //   }));
  // };
  // const handleDateAcknowledgementChange = (date, dateString) => {
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     dateOfAcknowledged: dateString, // Update the state
  //   }));
  // };
  // const handleDateFinalReplyChange = (date, dateString) => {
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     finalReplyDate: dateString, // Update the state
  //   }));
  // };
  const handleIncidentDateClick = (values) => {
    if (!showAutocomplete) {
      console.log('values agsereregvregrvgrthrt', values);
      console.log('formValuesdfgdgf', formValues);
      fetchAppointmentDates(formValues.patientId); // Fetch only when opening
    }
    setShowAutocomplete((prev) => !prev); // Toggle open/close
  };
  const handleSelectDate = (appointment, setFieldValue) => {
    const formattedDate = dayjs(appointment.appointmentDate).format(
      'DD/MM/YYYY'
    );

    setIncidentDate(formattedDate);
    setIncidentClass(false);
    setShowAutocomplete(false);

    console.log('Selected appointment--->>', appointment);

    // Update Formik fields
    setFieldValue('appointmentDate', formattedDate);
    setFieldValue('appointmentId', appointment.appointmentId);
    setFieldValue('complaintTo', appointment.doctorName);
    setFieldValue('complaintToId', appointment.doctorId);
    setFieldValue('complaintToType', appointment.complaintToType || 'D');

    // Optional: Update any additional state if required
  };

  console.log('showAutocomplete', showAutocomplete);

  const closeDeleteTaskPopup = () => {
    setDeleteTaskModal(false);
  };
  const closeEditPopUp = () => {
    setShowEditJobPatient(false);
    // setSelectedPhotoFile([]);
    // if (photoUploadRef.current) photoUploadRef.current.value = null;
    // setDueDateError(false);
    // setDueDate(null);
    // setSelectDocument('');
    // setDocumentTabData([]);
    // setAlreadySelectedFile([]);
    // handleClose();
    // setShowOtherField(false);
  };
  const handleCutButtonClick = (fileName) => {
    const updatedFiles = selectedPhotoFile.filter(
      (file) => file.name !== fileName
    );
    setSelectedPhotoFile(updatedFiles);
  };
  const handleCutButtonClickForPrev = (fileName) => {
    const updatedFiles = alreadySelectedFile.filter(
      (file) => file.fileName !== fileName
    );
    setAlreadySelectedFile(updatedFiles);
  };
  const handleButtonClick = () => {
    // Programmatically trigger a click event on the hidden file input
    photoUploadRef.current.click();
  };
  // console.log(editJobData)
  return (
    <div>
      <Modal
        size='xl'
        show={showEditJobPatient && editJobData}
        onHide={() => {
          closeEditPopUp();
        }}
        className=''
        centered
        aria-labelledby='contained-modal-title-vcenter'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Complaint(
            <span style={{ textTransform: 'capitalize', fontSize: '20px' }}>
              Created By:{' '}
              {editJobData.userName +
                '   ' +
                `${moment(editJobData.dateOfComplaint).format('DD/MM/YYYY')}`}
              {/* {editJobData.patientName +
                ` ${moment(editJobData.dateOfComplaint).format("DD/MM/YYYY")} `} */}
            </span>
            )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className=''>
          {}
          <Formik
            initialValues={formValues}
            validationSchema={validationSchema}
            onSubmit={saveEditPatient}
          >
            {({
              values,
              errors,
              resetForm,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form id='patientForm' onSubmit={handleSubmit}>
                {console.log('values', values)}
                <Row>
                  <Col lg={2} md={2}>
                    <label>Patiend Id</label>
                    <Form.Group className='mb-3'>
                      <input
                        style={{ borderColor: errors.notes ? 'red' : '' }}
                        name='notes'
                        className='form-control'
                        placeholder='Notes'
                        value={values.patientId}
                        onBlur={handleBlur}
                        error={errors.notes}
                        touched={touched.notes}
                        disabled
                        onChange={(e) => {
                          setFieldValue('notes', e.target.value);
                        }}
                        // onChange={(e) => {
                        //   handleChange(e); // Update form state
                        //   setSmsTemplate({
                        //     ...smsTemplate,
                        //     notes: e.target.value, // Update smsTemplate
                        //   });
                        // }}
                        ////style={{ width: '100%', marginTop: '-10px' }}
                        // required
                      />
                      {validationError.notes && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={10} md={10}>
                    <label>
                      Patient <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Form.Group
                      className='mb-3'
                      style={{ position: 'relative' }}
                    >
                      <input
                        // style={{ borderColor: smsTemplate.fullName === '' ? 'red' : '' }}
                        autoFocus
                        // disabled={patientJobDetails.firstName !== '' && true}
                        type='text'
                        name='patientName'
                        placeholder='Patient Name'
                        value={values.patientName}
                        // value={
                        //   values.patientId
                        //     ? `${values.patientName} :: ${values.patientId}`
                        //     : values.patientName
                        // }
                        // onChange={handleChange}
                        className='form-control'
                        // onBlur={handleBlur}
                        // error={errors.patientName}
                        // touched={touched.patientName}
                        // onChange={(e) => {
                        //   setPatientName(e.target.value);
                        //   onSearchPatient(e);
                        // }}

                        onChange={(e) => {
                          const newValue = e.target.value;

                          // Update Formik state
                          setFieldValue('patientName', newValue);

                          // Call your custom search function
                          onSearchPatient(e);
                        }}
                        // onClick={onSearchPatient}
                        required
                      />
                      {isPatientList && (
                        <div className='firstName-dropdown'>
                          <Autocomplete
                            type={patientList}
                            onFsListItem={(item) =>
                              onPatientItem(item, setFieldValue)
                            }
                          />
                        </div>
                      )}
                      {patientLoader && (
                        <p
                          style={{
                            position: 'absolute',
                            top: '6px',
                            right: '20px',
                            marginBottom: '0px',
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                      {validationError.patientName && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  {/* <Col md={12} lg={12}>
                    <label>Patient</label>
                    <Form.Group className='mb-3' controlId='formBasicName'>
                      <CustomInput
                        isDisabled={true}
                        type='text'
                        name='patientName'
                        value={values.patientName}
                        onChange={handleChange}
                        className='`form-control '
                        onBlur={handleBlur}
                        error={errors.patientName}
                        touched={touched.patientName}
                        // required
                      />
                      {touched.patientName && errors.patientName && (
                        <small className='text-danger error_field'>
                          {errors.patientName}
                        </small>
                      )}
                    </Form.Group>
                  </Col> */}
                </Row>
                <Row>
                  <Col md={12}>
                    <label>Notes</label>
                    <Form.Group className='mb-3'>
                      <textarea
                        cols='60'
                        rows='3'
                        style={{ borderColor: errors.notes ? 'red' : '' }}
                        name='notes'
                        className='form-control'
                        placeholder='Notes'
                        value={values.notes}
                        onBlur={handleBlur}
                        error={errors.notes}
                        touched={touched.notes}
                        onChange={(e) => {
                          const transformedValue = e.target.value.replace(
                            /(^\s*\w|[\.\!\?]\s*\w)/g,
                            (match) => match.toUpperCase()
                          );

                          handleChange({
                            target: {
                              name: e.target.name,
                              value: transformedValue,
                            },
                          });

                          // Also update smsTemplate with transformed text
                          setFormValues({
                            ...formValues,
                            notes: transformedValue,
                          });
                        }}
                        // onChange={(e) => {
                        //   setFieldValue('notes', e.target.value);
                        // }}
                        // onChange={(e) => {
                        //   handleChange(e); // Update form state
                        //   setSmsTemplate({
                        //     ...smsTemplate,
                        //     notes: e.target.value, // Update smsTemplate
                        //   });
                        // }}
                        ////style={{ width: '100%', marginTop: '-10px' }}
                        // required
                      />
                      {validationError.notes && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  {/* <Col md={12}>
                    <label>Task Details</label>
                    <Form.Group className='mb-3' controlId='formBasicName'>
                      <textarea
                        cols='60'
                        rows='3'
                        name='jobDetails'
                        className='form-control'
                        placeholder='Task Details'
                        value={values.jobDetails}
                        onBlur={handleBlur}
                        error={errors.jobDetails}
                        touched={touched.jobDetails}
                        onChange={handleChange}
                        //style={{ width: '100%', marginTop: '-10px' }}
                        // required
                      />
                      {touched.jobDetails && errors.jobDetails && (
                        <small className='text-danger error_field'>
                          {errors.jobDetails}
                        </small>
                      )}
                    </Form.Group>
                  </Col> */}
                  <Col md={12}>
                    <label>
                      Outcome <span style={{ color: 'red' }}>*</span>{' '}
                    </label>
                    <Form.Group className='mb-2'>
                      <CustomSelect
                        defaultValue='Select'
                        value={values.outCome}
                        name='outCome'
                        // onChange={handleChange}
                        onChange={(e) => {
                          setFieldValue('outCome', e.target.value);
                        }}
                        // onChange={(e) => {
                        //   handleChange(e);
                        //   setSmsTemplate({
                        //     ...smsTemplate,
                        //     outcome: e.target.value,
                        //   });
                        // }}
                        required
                        onBlur={handleBlur}
                        style={{
                          borderColor: errors.outCome ? 'red' : '',
                        }}
                        error={errors.outCome}
                        touched={touched.outCome}
                        // required
                        selectData={outcome}
                      />
                      {validationError.outCome && (
                        <small className='text-danger error_field'>
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row></Row>
                {showOtherField && (
                  <Row>
                    <Col lg={12} md={12}>
                      <Row>
                        <Col md={6}>
                          <label>Mobile Number</label>
                          <Form.Group className='mb-3'>
                            <Form.Control
                              disabled
                              type='text'
                              name='mobile'
                              className='form-control'
                              placeholder='Mobile Number'
                              value={values.mobile}
                              onBlur={handleBlur}
                              // onChange={handleChange}
                              onChange={(e) => {
                                const onlyNums = e.target.value.replace(
                                  /\D/g,
                                  ''
                                ); // Remove non-numeric characters
                                setFieldValue('mobile', onlyNums);
                              }}
                              isInvalid={!!errors.mobile && touched.mobile}
                              style={{
                                borderColor: errors.mobile ? 'red' : '',
                              }}
                              required
                            />
                            {errors.mobile && touched.mobile && (
                              <Form.Control.Feedback type='invalid'>
                                {errors.mobile}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <label>Email Id</label>
                          <Form.Group className='mb-3'>
                            <Form.Control
                              disabled
                              type='text'
                              name='email'
                              className='form-control'
                              placeholder='Email Id'
                              value={values.email}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isInvalid={!!errors.email && touched.email}
                              style={{ borderColor: errors.email ? 'red' : '' }}
                              required
                            />
                            {errors.email && touched.email && (
                              <Form.Control.Feedback type='invalid'>
                                {errors.email}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <label>
                            Date of Incident{' '}
                            <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Form.Group
                            className='mb-3'
                            style={{
                              position: 'relative',
                              backgroundColor: '#fff',
                            }}
                          >
                            <input
                              type='text'
                              name='incidentDate'
                              placeholder='Select Date of Incident'
                              // value={
                              //   values.appointmentDate
                              //     ? values.appointmentDate
                              //     : incidentDate
                              // }
                              value={values.appointmentDate}
                              format='DD/MM/YYYY'
                              readOnly
                              onClick={handleIncidentDateClick}
                              // className="form-control"
                              className={`form-control ${incidentClass ? 'is-invalid' : ''}`}
                              // onBlur={() => setIncidentClass(!incidentDate)} // Toggle error if empty
                              // aria-invalid={!incidentDate}
                              style={{
                                cursor: 'pointer',
                                paddingRight: '30px',
                              }} // Add space for icon
                              required
                            />

                            {/* Dropdown Icon */}
                            <FaCaretDown
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                pointerEvents: 'none',
                                color: '#888',
                              }}
                            />
                            {incidentClass && (
                              <div className='invalid-feedback'>
                                Date of Incident is required.
                              </div>
                            )}
                            {/* Autocomplete List */}
                            {showAutocomplete && (
                              <div className='firstName-dropdown'>
                                <AutoAppointmentComplete
                                  type={appointmentDates}
                                  onFsListItem={(item) =>
                                    handleSelectDate(item, setFieldValue)
                                  }
                                />
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <label>
                            Staff / Doctor Involved{' '}
                            <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Form.Group
                            className='mb-3'
                            style={{ position: 'relative' }}
                          >
                            <input
                              type='text'
                              name='complaintTo'
                              placeholder='Search Doctor'
                              value={values.complaintTo}
                              className='form-control'
                              onChange={(e) => {
                                handleChange(e); // ✅ Update Formik state
                                onSearchDoctor(e); // ✅ Perform search
                              }}
                              required
                            />

                            {/* Autocomplete Dropdown */}
                            {isDoctorList && (
                              <div className='firstName-dropdown'>
                                <Autocomplete
                                  type={doctorList}
                                  onFsListItem={(item) =>
                                    onDoctorItem(item, setFieldValue)
                                  }
                                />
                              </div>
                            )}

                            {/* Loading Spinner */}
                            {doctorLoader && (
                              <p
                                style={{
                                  position: 'absolute',
                                  top: '6px',
                                  right: '20px',
                                }}
                              >
                                <Spin />
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <label>Date of Complaint </label>
                          <Form.Group className='mb-3'>
                            <DatePicker
                              value={
                                formValues.dateOfComplaint
                                  ? dayjs(
                                      formValues.dateOfComplaint,
                                      'DD/MM/YYYY'
                                    )
                                  : null
                              }
                              format='DD/MM/YYYY'
                              className='custom-datepicker'
                              style={{ width: '100%', height: '38px' }}
                              required
                              onChange={(date, dateString) => {
                                console.log(
                                  'Selected Date of Complaint:',
                                  dateString
                                ); // Debugging

                                // Calculate deadline date
                                const calculatedDeadline =
                                  calculateDeadlineDate(
                                    dayjs(dateString, 'DD/MM/YYYY')
                                  ).format('DD/MM/YYYY');

                                // Update both dateOfComplaint and deadLineToReply
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  dateOfComplaint: dateString || '',
                                  deadLineToReply: calculatedDeadline, // Auto-update deadline date
                                }));

                                console.log(
                                  'Calculated Deadline Date:',
                                  calculatedDeadline
                                ); // Debugging
                              }}
                            />
                          </Form.Group>
                        </Col>

                        {/* <Col md={6}>
                          <label>Date of Complaint </label>
                          <Form.Group className='mb-3'>
                            <DatePicker
                              value={
                                formValues.dateOfComplaint
                                  ? dayjs(
                                      formValues.dateOfComplaint,
                                      'DD/MM/YYYY'
                                    )
                                  : null
                              }
                              format='DD/MM/YYYY'
                              className='custom-datepicker'
                              style={{
                                width: '100%',
                                height: '38px',
                              }}
                              required
                              onChange={(date, dateString) => {
                                console.log(
                                  'Selected Date of Complaint:',
                                  dateString
                                ); // Debugging
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  dateOfComplaint: dateString || '', // Ensure correct state update
                                }));
                              }}
                            />

                            {deuDateError && (
                              <small className='text-danger error_field'>
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col> */}

                        <Col md={6}>
                          <label>Date of Acknowledgement</label>
                          <Form.Group className='mb-3'>
                            <DatePicker
                              value={
                                formValues.dateOfAcknowledged
                                  ? dayjs(
                                      formValues.dateOfAcknowledged,
                                      'DD/MM/YYYY'
                                    )
                                  : null // Ensuring proper handling of empty values
                              }
                              // value={
                              //   values.dateOfAcknowledged
                              //     ? dayjs(
                              //         formValues.dateOfAcknowledged,
                              //         'DD/MM/YYYY'
                              //       )
                              //     : null
                              // }
                              onChange={(date, dateString) => {
                                console.log('Selected Date:', dateString); // Debugging
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  dateOfAcknowledged: dateString || '', // Ensure correct state update
                                }));
                              }}
                              // onChange={handleDateAcknowledgementChange}
                              format='DD/MM/YYYY'
                              style={{ width: '100%', height: '38px' }}
                            />
                            {deuDateError && (
                              <small className='text-danger error_field'>
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12} md={12}>
                      <Row>
                        <Col md={6}>
                          <label>Deadline Date</label>
                          <Form.Group className='mb-3'>
                            <DatePicker
                              value={
                                formValues.deadLineToReply
                                  ? dayjs(
                                      formValues.deadLineToReply,
                                      'DD/MM/YYYY'
                                    )
                                  : null
                              }
                              format='DD/MM/YYYY'
                              style={{ width: '100%', height: '38px' }}
                              required
                              onChange={(date, dateString) => {
                                console.log(
                                  'Selected Date of Complaint:',
                                  dateString
                                ); // Debugging
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  deadLineToReply: dateString || '', // Ensure correct state update
                                }));
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <label>Final Reply Date</label>
                          <Form.Group className='mb-3'>
                            <DatePicker
                              // value={
                              //   values.finalReplyDate
                              //     ? dayjs(
                              //         formValues.finalReplyDate,
                              //         'DD/MM/YYYY'
                              //       )
                              //     : null
                              // }
                              value={
                                formValues.finalReplyDate
                                  ? dayjs(
                                      formValues.finalReplyDate,
                                      'DD/MM/YYYY'
                                    )
                                  : null // Ensuring proper handling of empty values
                              }
                              onChange={(date, dateString) => {
                                console.log('Selected Date:', dateString); // Debugging
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  finalReplyDate: dateString || '', // Ensure correct state update
                                }));
                              }}
                              //  onChange={handleDateFinalReplyChange}
                              format='DD/MM/YYYY'
                              style={{ width: '100%', height: '38px' }}
                            />
                            {deuDateError && (
                              <small className='text-danger error_field'>
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}
                {
                  <Button
                    onClick={() => {
                      setShowOtherField(!showOtherField);
                    }}
                  >
                    {showOtherField ? 'Show Less' : 'Show More'}
                  </Button>
                }
                {/* <div style={{display:"grid",gridTemplateColumns:"1fr 1fr"}}>
                  <div></div>
                </div> */}
                <div
                  className='my-4 mb-3 p-2 d-flex'
                  style={{ justifyContent: 'space-between' }}
                >
                  <div style={{ display: 'flex' }}>
                    <Button
                      disabled={loading}
                      type='submit'
                      variant={'outline-primary'}
                    >
                      {loading ? 'Updating...' : 'Update'}
                    </Button>
                    <CustomDangerButton
                      cancelOnClick={() => closeEditPopUp()}
                      variant='danger'
                      name='Cancel'
                    />
                  </div>
                  {roleListStatus.length > 0 && (
                    <button
                      className='btn btn-danger me-2'
                      type='button'
                      onClick={handleDeleteTask}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      {editJobData && (
        <Modal
          size='xs'
          show={deleteTaskModal}
          onHide={closeDeleteTaskPopup}
          className='newModels'
          centered
          aria-labelledby='contained-modal-title-vcenter'
        >
          <Modal.Body className=''>
            <div className='d-flex justify-content-between'>
              <h4 className='text-secondary ' style={{ fontWeight: '600' }}>
                WARNING!
              </h4>
            </div>
            <h6 className='mt-3'>Are you sure you want to delete this complaint?</h6>
            <div className='d-flex mt-4 justify-content-around'>
              <Button
                onClick={() => completelyDeletedTask(editJobData?.ID)}
                className='px-5 '
                variant='success'
              >
                Yes
              </Button>
              <Button
                onClick={closeDeleteTaskPopup}
                className='px-5 '
                variant='danger'
              >
                No
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <Modal
        size='md'
        show={loadingForDelete}
        centered
        className='labloader_modal'
        style={{ zIndex: '9999' }}
      >
        <Modal.Body>
          <div className='spinner-container'>
            <div className={`loading-spinner`}></div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default EditPatientComplaintsDialog;
